import Vue from "vue"
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})


export const store = new Vuex.Store({
    state: {
        promocode: null,
        basket: [],
        isBasketOpen: false,
        isMenuOpen: false,
        isLoginFormOpen: false,
        customerParams: {}
    },
    actions: {
        loadBasket(context) {
            return Vue.http.post('/customer/load-basket', this.basket).then(response => {
                context.commit('setBasket', response.data)
                return response.data
            })
        }
    },
    getters: {
        basketTotal(state) {
            if(!state.basket.length) return 0;
            return state.basket.reduce((total, item) => total + item.count * (item.price_after_discount || item.current_price.amount), 0)
        },
        basketTotalWeight(state) {
            if(!state.basket.length) return 0;
            return state.basket.reduce((total, item) => total + item.count * item.weight, 0)
        },
        basketTotalVolume(state) {
            if(!state.basket.length) return 0;
            return state.basket.reduce((total, item) => total + item.count * item.volume, 0)
        },
        basketTotalCount(state) {
            if(!state.basket.length) return 0;
            return state.basket.reduce((total, item) => total + item.count , 0)
        },
        basketMaxPositionWeight(state) {
            if(!state.basket.length) return 0;
            let positionWeight = state.basket.map((item) => item.weight)
            window.console.log('--', positionWeight);
            return Math.max.apply(null, positionWeight)
        }
    },
    mutations: {
        addToBasket(state, bitem) {
            let existItem = state.basket.filter(item => item.id == bitem.id)
            if(existItem.length == 0){
                state.basket.push(bitem)
            }else{
                existItem.pop().count = bitem.count
            }
        },
        setCustomerParams(state, customerParams) {
            state.customerParams = customerParams
        },
        setBasket(state, items) {
            state.basket = items
        },
        savePromocode(state, promocode) {
            state.promocode = promocode
        },
        removePromocode(state) {
            state.promocode = null
            state.basket.map( item => {
                item.price_after_discount = null
                item.promocode_type_id = null
                item.hasDiscount = item.current_price.amount != item.base_price.amount
            })
        },
        removeFromBasket(state, id) {
            let items = this.state.basket.filter(item => item.id != id)
            this.commit('setBasket', items);
        },
        incrementBasket(state, id) {
            let item = state.basket.filter( item => item.id == id ).pop()
            if(item.base_stock.cnt > item.count){
                item.count++
            }
        },
        decrementBasket(state, id) {
            let item = state.basket.filter( item => item.id == id ).pop()
            if(item.count > 1){
                item.count--
            }
        },
        setPromocodePrice(state, positionItem) {
            let item = state.basket.filter( item => item.id == positionItem.product_id ).pop()
            if(positionItem.price_after_discount){
                item.price_after_discount = positionItem.price_after_discount * 100
                item.price_after_discount_key = positionItem.price_after_discount_key

                item.promocode_type_id = positionItem.promocode_type_id
                item.hasDiscount = true
            }else{
                item.price_after_discount = null
                item.promocode_type_id = null
                item.hasDiscount = item.current_price.amount != item.base_price.amount
            }
        },
        clearBasket(state) {
            state.basket = []
        }



    },
    plugins: [vuexLocal.plugin]
})